import { formatMoneySmart } from '../shared/format';
import type { TicketCampaignSnapshot } from './ticketCampaignSnapshot';

export interface CampaignDetailRow {
  label: string;
  value: string;
}

const formatDate = (iso?: string) => {
  if (!iso) return '';
  return new Date(iso + 'T00:00:00').toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const PAYMENT_LABELS: Record<NonNullable<TicketCampaignSnapshot['paymentPlan']>, string> = {
  upfront: 'Upfront',
  monthly: 'Month by month',
};

export function buildCampaignDetailRows(
  snapshot: TicketCampaignSnapshot | null,
): CampaignDetailRow[] {
  if (!snapshot) return [];

  const rows: CampaignDetailRow[] = [];

  if (snapshot.businessName) {
    rows.push({ label: 'Business', value: snapshot.businessName });
  }
  if (snapshot.businessWebsite) {
    rows.push({ label: 'Website', value: snapshot.businessWebsite });
  }
  if (snapshot.contactEmail) {
    rows.push({ label: 'Email', value: snapshot.contactEmail });
  }
  if (snapshot.contactName) {
    rows.push({ label: 'Contact', value: snapshot.contactName });
  }
  if (snapshot.contactPhone) {
    rows.push({ label: 'Phone number', value: snapshot.contactPhone });
  }
  if (snapshot.startDate) {
    rows.push({ label: 'Start date', value: formatDate(snapshot.startDate) });
  }
  if (snapshot.endDate) {
    rows.push({ label: 'End date', value: formatDate(snapshot.endDate) });
  }
  if (snapshot.budget != null && snapshot.budget > 0) {
    rows.push({ label: 'Budget', value: formatMoneySmart(snapshot.budget) });
  }
  if (snapshot.targeting) {
    rows.push({ label: 'Targeting', value: snapshot.targeting });
  }
  if (snapshot.paymentPlan) {
    rows.push({ label: 'Payment type', value: PAYMENT_LABELS[snapshot.paymentPlan] });
  }

  return rows;
}
